/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import OrganizationSubscribersTable from '../components/Tables/OrganizationSubscribersTable';
import DocumentTitle from '../components/DocumentTitle';

const ContactsScreen = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <DocumentTitle title={t('Contacts')} />
      <OrganizationSubscribersTable />
    </Fragment>
  );
};

export default ContactsScreen;
